<template>
    <div v-if="user">
        <div class="tabsContainer mt-3">
            <div class="tabContent">
                <div class="row">
                    <div class="col-sm-3">
                        <div class="form-group">
                            <label>
                                <localized-text localizedKey="Stato" text="Stato"></localized-text>
                            </label>
                            <select class="form-control" v-model="user.statuses">
                                <option v-for="item in statuses" :value="item">{{item}}</option>
                            </select>
                        </div>
                        <div class="scrollListContainer" ref="scrollListContainer">
                            <div class="scrollListItem" v-for="(item, i) in user.statuses.statusHistory" :key="i">
                                <div>
                                    <b>{{item.value.from}} → {{item.value.to}}</b>
                                </div>
                                <div>
                                    <!-- <span class="text-primary">{{item.value.author && item.value.author.name}}</span> -->
                                </div>
                                <div>
                                    {{$filters.date(item.date, "DD/MM/yyyy HH:mm")}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="form-group">
                            <label>
                                <localized-text localizedKey="Substato" text="Substato"></localized-text>
                            </label>
                            <select class="form-control" v-model="user.statuses.subStatus">
                                <option v-for="item in subStatuses" :value="item">{{item}}</option>
                            </select>
                        </div>
                        <div class="scrollListContainer" ref="scrollListContainer">
                            <div class="scrollListItem" v-for="(item, i) in user.statuses.subStatusHistory" :key="i">
                                <div>
                                    <b>{{item.value.from}} → {{item.value.to}}</b>
                                </div>
                                <div>
                                    <!-- <span class="text-primary">{{item.value.author && item.value.author.name}}</span> -->
                                </div>
                                <div>
                                    {{$filters.date(item.date, "DD/MM/yyyy HH:mm")}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label>
                                <localized-text localizedKey="Product level" text="Product level"></localized-text>
                            </label>
                            <input type="number" class="form-control" v-model="user.statuses.productLevel" />
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label>
                                <localized-text localizedKey="Nazione" text="Nazione"></localized-text>
                            </label>
                            <select class="form-control" v-model="user.country">
                                <option v-for="item in countries" :value="item">{{item}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label>
                                <localized-text localizedKey="Pagabile" text="Pagabile"></localized-text>
                            </label>
                            <div>
                                <toggler v-model="user.isPayable"></toggler>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-sm-6">
                        <div class="boxTitle">
                            <localized-text localizedKey="Qualifiche" text="Qualifiche"></localized-text>
                        </div>
                        <qualification v-model="user"></qualification>
                    </div>
                    <div class="col-sm-6">
                        <div class="d-flex">
                            <div class="boxTitle">
                                <localized-text localizedKey="Scadenze" text="Scadenze"></localized-text>
                            </div>
                            <div class="ms-2">
                                <button class="btn btn-primary btn-sm" @click="addToDo">
                                    <localized-text localizedKey="Nuova" text="Nuova"></localized-text>
                                </button>
                            </div>
                        </div>
                        <div class="scrollListContainer" ref="scrollListContainer">
                            <div class="scrollListItem" v-if="user.statuses.scadenze.length == 0">
                                <localized-text localizedKey="Nessuna scadenza inserita" text="Nessuna scadenza inserita"></localized-text>
                            </div>
                            <div class="scrollListItem" v-for="(item, i) in user.statuses.scadenze" :key="i">
                                <div class="d-flex justify-content-between">
                                    <b>{{item.author.name}}</b>
                                    <div>
                                        <span class="text-primary">{{item.toDoType}}</span>
                                        -
                                        <b>{{$filters.date(item.startDate, "DD/MM/yyyy HH:mm")}}</b>
                                    </div>
                                </div>
                                <div>
                                    {{item.text}}
                                </div>
                                <div>
                                    <template v-if="item.attachments.length > 0">
                                        <div v-for="(x, i) in item.attachments" :key="i" class="fs-12">
                                            <a class="text-primary" :href="x.publicUrl" target="_blank">
                                                {{x.fileName}}
                                            </a>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import * as OM from '@/model';
import * as VM from '@/viewmodel';
import * as CONST from '@/const';
import { mixins, Options, Vue } from 'vue-class-component';
import { ProjectConfigClient } from '@/services/Services';
import store from '@/store';
import { LocalizationServices } from '@/services/LocalizationServices';
import { ModalServices } from '@/services/ModalServices';
import { Prop } from 'vue-property-decorator';
import newToDoModal from './newToDoModal.vue';

@Options({})
export default class projectStatusesPairs extends Vue {

    @Prop() user: OM.BaseUser;
    
    statuses: string[] = [];
    subStatuses: string[] = [];
    countries: string[] = [];
    lists: string[] = [];

    created(){
        ProjectConfigClient.getProjectConfig()
        .then(x => {
            this.statuses = x.leadStatuses;
            this.subStatuses = x.leadSubStatuses;
            this.countries = x.countryConfigList.map(x => x.alpha2Code);
        })
    }

    addToDo(){
        this.$opModal.show(newToDoModal, {
            user: this.user,
            onDone: (x: OM.ToDo) => {
                this.user.statuses.scadenze.unshift(x);
            }
        })
    }

}

</script>
